<template>
<div class="c-selectService">
  <h2 class="text-center mb--3">Wybierz zakres usług</h2>
  <div class="c-selectService__wrap">
    <div class="c-selectService__tile" v-for="service in getServices" :key="service.id" v-on:click="selectedService = service; lead.service = service.name" v-bind:class="{'c-selectService__tile--active':selectedService == service}">
      <img :src="service.image" alt="">
      <img src="@/assets/images/service-mask.png" alt="Wybrana usługa serwisowa" class="c-selectService__mask">
      <h3 class="mb--1">{{ service.name }}</h3>
      <div class="c-selectService__moreBtn pb--2" v-on:click="details = service">Szczegóły<img src="@/assets/images/tick.png" alt="<"></div>
    </div>
  </div>
  <Modal v-if="details" v-on:close="details = null">
    <template slot="title">{{details.name}}</template>
    <template slot="content">{{details.text}}</template>
  </Modal>
  <h2 class="text-center mb--3">Usługi promocyjne</h2>
  <div class="c-selectService__wrap">

    <div class="c-selectService__tile c-selectService__tile--sm" v-for="specialOffer in getSpecialOffers" :key="specialOffer.id" v-on:click="selectedSpecialService = specialOffer; lead.servicetemp = specialOffer.name"
      v-bind:class="{'c-selectService__tile--active':selectedSpecialService == specialOffer}">
      <img :src="specialOffer.image" alt="">
      <img src="@/assets/images/service-mask.png" alt="Wybrana usługa serwisowa" class="c-selectService__mask">
      <h3 class="c-selectService__name mb--1" v-html="specialOffer.displayName"></h3>

      <a :href="specialOffer.link" target="_blank">
        <div class="c-selectService__moreBtn pb--1">
          Szczegóły<img src="@/assets/images/arrow.png" alt="<">
        </div>
      </a>
    </div>

    <!-- <div class="c-selectService__tile c-selectService__tile--sm">
      <img src="@/assets/images/rozrzad.png" alt="">
      <h3 class="c-selectService__name mb--1">
        Korzyść do -20% <br>
        dla silników 2.0 TDI, <br>
        rocznik auta 2019-2012
      </h3>
      <a href="https://www.krotoski.com/wymiana-rozrzadu/" target="_blank">
        <div class="c-selectService__moreBtn pb--1">
          Szczegóły<img src="@/assets/images/arrow.png" alt="<">
        </div>
      </a>
    </div> -->
  </div>

  <h2 class="mt--3 mb--1 text-center">Usługi dodatkowe</h2>
  <div class="additional_services">
    <label class="mt--2 ml--1">
    <input type="checkbox" v-model="lead.video_service" true-value="TAK" false-value="NIE"> <strong>Krotoski Video Serwis (usługa bezpłatna)</strong>
    <ul class="mb--0">
      <li>video raport z usługi serwisowej,</li>
      <li>możliwość podjęcia decyzji o naprawie online,</li>
      <li>bez instalowania aplikacji</li>
    </ul>
  </label>
    <label class="ml--1">
      <input type="checkbox" v-model="lead.need_replacement_car" true-value="TAK" false-value="NIE"> <strong>Potrzebuję samochodu zastępczego</strong>
    </label>
    <label class="ml--1">
      <input type="checkbox" v-model="lead.need_wait_for_end" true-value="TAK" false-value="NIE"> <strong>Chcę czekać na ukończenie naprawy pojazdu na miejscu w&nbsp;serwisie</strong>
    </label>
    <label class="ml--1">
      <input type="checkbox" v-model="lead.door_to_door" true-value="TAK" false-value="NIE"> <strong>Door to door</strong>
      <p>
        Dzięki usłudze Door to Door nie tracisz czasu na dojazdy do serwisu i oczekiwanie.
      </p>
      <p>
        Usługa obejmuje transport samochodu do serwisu, oraz dostarczenie auta
        <br>
        w wyznaczone miejsce, po wizycie w serwisie.
      </p>
    </label>
  </div>
</div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import lead from '../mixins/lead.js'
export default {

  data() {
    return {
      selectedService: null,
      selectedSpecialService: null,
      details: null
    }
  },
  mixins: [lead],
  computed: {
    ...mapGetters([
      'getServices',
      'getSpecialOffers'
    ])
  }
}
</script>
<style lang="scss">
.c-selectService {
    $t: &;
    max-width: 1080px;
    margin: 0 auto;
    &__wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 1rem;
    }
    &__name {
        font-size: 1em;
    }
    &__tile {
        cursor: pointer;
        text-align: center;
        position: relative;

        @media (min-width:960px) {
            width: calc(100%/3);
        }
        &--sm {
            @media(min-width: 960px) {
                width: calc(100%/2);
            }
        }
        &--active {
            #{$t}__mask {
                opacity: 1;
            }
        }
    }
    &__mask {
        position: absolute;
        top: 0.25rem;
        left: -.5rem;
        right: 0;
        margin: 0 auto;
        line-height: 0;
        opacity: 0;
        transition: opacity 0.5s;
    }
    &__d2d {
        box-shadow: 0 0 20px 0 rgba(0,0,0,0.16);
        padding: 1rem;
        &__select {
            display: flex;
        }
    }
    &__moreBtn {
        padding-bottom: 1rem;
        font-weight: bold;
        img {
            width: 1rem;
            height: auto;
            margin-left: 0.25rem;
        }
    }
}
.additional_services{
  max-width: 680px;
  margin:0 auto;
}
</style>
